export default function SelectField({ label, value, onChange, options }) {
  return (
    <div>
      <label className="text-xs text-neutral-400 uppercase tracking-wider mb-2 block">
        {label}
      </label>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-4 py-2.5 bg-black/40 border border-neutral-800 rounded-lg text-white focus:outline-none focus:border-brand-gold/50 text-sm"
      >
        {options.map((o) => (
          <option key={o.v} value={o.v}>
            {o.l}
          </option>
        ))}
      </select>
    </div>
  );
}
